import { styled } from '@mui/system'
import { Box } from '@mui/material'

export const ReportControlButtons = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-end',
  gap: theme.spacing(2),
  [theme.breakpoints.down('sm')]: {
    alignItems: 'stretch',
    justifyContent: 'flex-start',
    width: '100%'
  }
}))
